import { boolean } from 'yup'
import { safify } from '../utils/safify'

export const includeImages = boolean()
  .default(true)
  .meta({
    label: 'Include images',
    description: 'An image will make your content far more engaging and attention grabbing',
    autoFill: true,
  })
  .transform(safify)
